var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmarkBlackBold = function SvgCheckmarkBlackBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.998 8.931-2.134-2.134a1.006 1.006 0 0 0-1.423 0L12.646 19.592l-6.086-6.13a1.006 1.006 0 0 0-1.423 0l-2.134 2.134a1.006 1.006 0 0 0 0 1.423l8.924 8.984c.393.393 1.03.393 1.423 0l15.648-15.649a1.006 1.006 0 0 0 0-1.423"
  })));
};
export default SvgCheckmarkBlackBold;